<template>
  <div v-if="isVisible">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <div v-html="html" />
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    html: {
      type: String,
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
